import actionCreatorFactory from "typescript-fsa";
import { SelectedCell } from "./types";

const create = actionCreatorFactory("Selected Cells");

export const selectCell = create<SelectedCell>("SELECT");
export const deselectCells = create("DESELECT");



// WEBPACK FOOTER //
// ./src/spread/model/selectedCells/actions.ts